export default __webpack_public_path__ + "static/media/demo1.6ab5c6d2.png";